<template>
  <Teleport to="body">
    <div v-if="isVisible" class="modal-backdrop" @click="cancel">
      <div class="modal-content" @click.stop>
        <h3 class="modal-title">{{ title }}</h3>
        <p class="modal-message">{{ message }}</p>
        <div class="modal-buttons">
          <button class="confirm-btn" @click="confirm">{{ confirmText }}</button>
          <button class="cancel-btn" @click="cancel">{{ cancelText }}</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, onUnmounted } from 'vue';

const isVisible = ref(false);
const title = ref('');
const message = ref('');
const confirmText = ref('Ano');
const cancelText = ref('Ne');

let resolvePromise = null;

// Čistící funkce pro případ zničení komponenty
onUnmounted(() => {
  if (resolvePromise) {
    resolvePromise(false);
    resolvePromise = null;
  }
});

// Metoda pro otevření dialogu
const open = (options) => {
  // Nastavíme hodnoty
  title.value = options.title || 'Potvrdit akci';
  message.value = options.message || 'Opravdu chcete provést tuto akci?';
  confirmText.value = options.confirmText || 'Ano';
  cancelText.value = options.cancelText || 'Ne';
  
  // Použijeme nextTick pro zajištění, že komponenta je aktualizovaná před zobrazením
  return new Promise((resolve) => {
    resolvePromise = resolve;
    // Zobrazíme dialog až v další tikovi reaktivity
    setTimeout(() => {
      isVisible.value = true;
    }, 0);
  });
};

// Potvrzení akce
const confirm = () => {
  isVisible.value = false;
  if (resolvePromise) {
    resolvePromise(true);
    resolvePromise = null;
  }
};

// Zrušení akce
const cancel = () => {
  isVisible.value = false;
  if (resolvePromise) {
    resolvePromise(false);
    resolvePromise = null;
  }
};

// Exportujeme metody, které budou dostupné přes ref
defineExpose({
  open,
});
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  background-color: white;
  padding: 1.5rem;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 400px;
  animation: modal-appear 0.2s ease-out;
}

.modal-title {
  margin-top: 0;
  color: #6655aa;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.modal-message {
  margin-bottom: 1.5rem;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.confirm-btn {
  background-color: #6655aa;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.confirm-btn:hover {
  background-color: #554499;
}

.cancel-btn {
  background-color: #f0f0f0;
  color: #333;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-btn:hover {
  background-color: #e0e0e0;
}

@keyframes modal-appear {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
